module.exports = __webpack_public_path__ + "img/logo.027c46a0.png";